import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { startWith, map, of, delay } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AlertComponent } from '../alert/alert.component';
import { DataService } from '../data.service';
import { HttpService } from '../http.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-createdialog',
  templateUrl: './createdialog.component.html',
  styleUrls: ['./createdialog.component.scss']
})
export class CreatedialogComponent implements OnInit,AfterViewInit {
  city: any;
  cityid: any;
  streamid: any;
  classId: any;
  campus: any;
  campusId: any;
  classAndstream: any;
  stream: any;
  class: any;
  coursetrack: any;
  campuswisetracks: any
  list: any;
  cityName: any;
  cityOptions: any;
  campusName: any;
  campusOptions: any;
  className: any; 
  streamName: any;
  groupName: any;
  coursetrackName: any;
  classOptions: any;
  streamOptions: any;
  groupOptions: any;
  coursetrackOptions: any;
  campustrackOptions: any;
  routelink: String = "[creation]";
  filterBy: any = 'PENDING';
  YEAR: any;
  pendingImage: any = '../../assets/canedit.svg';
  editingRoute: any = 'goto()';
  pendingtick: any = 'none';
  approvedtick: any = 'none';
  rejectedtick: any = 'none';
  filterdisplay: any = 'none'
  campusTrackId: any;
  classname: any;
  courseTrackName: any;
  CampusWiseCourseTracks: any;
  grouplist: any;
  groupNameList: any;
  defaultCity: any;
  cityObject: any;
  campusObject: any;
  classObject: any;
  streamobject: any;
  coursetrackobject: any;
  groupobject: any;
  defaultCoursetrack: any;
  defaultCampus: any;
  defaultClass: any;
  defaultgroup: any;
  defaultstream: any;
  coursetrackcolor:any='#CAD2DE'
  coursetrackcolor1: string='#666';
  dataDisplay: any;
  displayvalue: string='flex';
  coursetrackid: any;
  groupId: any;
  groupwisestream: any;
  showComponent1 = true;
  showComponent2 = false;
 app:any
  toggleComponents() {
    this.showComponent1 = !this.showComponent1;
    this.showComponent2 = !this.showComponent2;
  }
  constructor(private route: Router, private service: HttpService,private spinner: NgxSpinnerService,private dtservice:DataService,private dialog:MatDialog, private dialogRef: MatDialogRef<CreatedialogComponent>) { }
  ngAfterViewInit(): void {
  }

  main:any;
  ngOnInit(): void {

    

    if(this.dtservice.campusId!=null)
    {
      this.defaultCity=this.dtservice.getcityName()
      this.defaultCampus=this.dtservice.getcampusName()
      this.defaultClass=this.dtservice.getclassName()
      this.defaultgroup=this.dtservice.getgroupName()
      this.defaultstream=this.dtservice.getstreamName()
      this.defaultCoursetrack=this.dtservice.getcoursetrackName()
      this.coursetrackobject=this.dtservice.coursetrack;
      this.grouplist=this.dtservice.getGroupLIst();
     
        
      this.getlistAftersave(this.dtservice.campusId,this.dtservice.classId,this.dtservice.streamId,this.dtservice.coursetrack.courseTrackId,this.dtservice.group.groupId)
      this.main=new FormGroup({
        "citycontrol":new FormControl(),
        "campusControl":new FormControl(),
        "classControl":new FormControl(),
        "streamcontrol":new FormControl(),
        "groupcontrol":new FormControl(),
        "coursetrackcontrol":new FormControl(),
        "citycontrol2":new FormControl(this.dtservice.getcityName()),
        "campusControl2":new FormControl(this.dtservice.getcampusName()),
        "classControl2":new FormControl(this.dtservice.getclassName()),
        "streamcontrol2":new FormControl(this.dtservice.getstreamName()),
        "groupcontrol2":new FormControl(this.dtservice.getgroupName()),
        "coursetrackcontrol2":new FormControl(this.dtservice.getcoursetrackName())
      })
      this.city=this.dtservice.getCityLIst()
    this.cityOptions = this.main.get('citycontrol').valueChanges.pipe(
      startWith(''),
      map((value:any) => this.Filter(value,this.city,'cityName' ))
    );
    this.campus=this.dtservice.getCampusLIst()
    this.campusOptions = this.main.get('campusControl').valueChanges.pipe(
      startWith(''),
      map((value:any) => this.Filter(value ,this.campus,'campusName'))
    )
    this.class=this.dtservice.getClassLIst()
        this.classOptions = this.main.get('classControl').valueChanges.pipe(
          startWith(''),
          map((value:any) => this.Filter(value,this.class,'className' ))
        )
        this.groupNameList= this.dtservice.getGroupLIst().groupNameList
    this.groupName= this.groupNameList.map((grouplist:any)=>grouplist.groupName);
    this.groupOptions=this.main.get('groupcontrol').valueChanges.pipe(
      startWith(''),
      map((value:any) => this.Filter(value,this.groupNameList,'groupName' ))
    )
    this.streamList=this.dtservice.getStreamLIst()
    this.streamOptions = this.main.get('streamcontrol').valueChanges.pipe(
      startWith(''),
      map((value:any) => this.Filter(value,this.streamList,'streamName' ))
    )

    this.CampusWiseCourseTracks= this.dtservice.getCourseTrackLIst()
    this.campustrackOptions = this.main.get('coursetrackcontrol').valueChanges.pipe(
      startWith(''),
      map((value:any) => this.Filter(value,this.CampusWiseCourseTracks,'courseTrackName' ))
    );
    }
    else{
         this.main=new FormGroup({
      "citycontrol":new FormControl(),
      "campusControl":new FormControl(),
      "classControl":new FormControl(),
      "streamcontrol":new FormControl(),
      "groupcontrol":new FormControl(),
      "coursetrackcontrol":new FormControl(),
      "citycontrol2":new FormControl(),
      "campusControl2":new FormControl(),
      "classControl2":new FormControl(),
      "streamcontrol2":new FormControl(),
      "groupcontrol2":new FormControl(),
      "coursetrackcontrol2":new FormControl()
    })
    
    }
    this.spinner.show();
    this.service.getCity().subscribe((res: any) => {
      this.city = res;  
    this.spinner.hide();
      this.dtservice.setCityLIst(this.city)
      this.cityOptions = this.main.get('citycontrol').valueChanges.pipe(
        startWith(''),
        map((value:any) => this.Filter(value,this.city,'cityName' ))
      );
    });
    
    
  }
  getcity(){
   
  }
  clearcampus() {
    this.main.get('campusControl2').reset();
    this.campusOptions = of([]).pipe(delay(0));
   this.defaultCampus=''
   
    this.clearclass();
  }
  toResetCityIntput() {
    this.main.get("citycontrol").setValue("");
  }


  toResetCampusIntput() {
    this.main.get("campusControl").setValue("");
  }


  toResetClassIntput() {
    this.main.get("classControl").setValue("");
  }
  toResetCourseTrackIntput() {
    this.main.get("coursetrackcontrol").setValue("");
  }
 
  toResetStreamIntput() {
    this.main.get("streamcontrol").setValue("");
  }
  toResetGroupIntput() {
    this.main.get("groupcontrol").setValue("");
  }
  clearclass() {
    this.main.get('classControl2').reset();

     this.classOptions = of([]).pipe(delay(0));
    this.defaultClass=''
    this.class=[]
    this.clearGroup()
    
  }
  
  clearstream() {
    this.main.get('streamcontrol2').reset();
    //  this.streamOptions=[]
     
    this.defaultstream=''
    // this.streamList=[]
    this.clearcoursetrack();
    this.streamOptions = of([]).pipe(delay(0));
  }
  
  clearcoursetrack() {
    this.main.get('coursetrackcontrol2').reset();
// this.coursetrackOptions=[]
this.campustrackOptions = of([]).pipe(delay(0));
    this.defaultCoursetrack=''
    // this.CampusWiseCourseTracks=[]
  }
  
  clearGroup() {
    this.main.get('groupcontrol2').reset();

    this.groupOptions = of([]).pipe(delay(0));
    this.defaultgroup=''
    this.groupNameList=[]
    this.clearstream();
  }
  
  filterDisplay() {
    this.filterdisplay = 'flex';

  }
  changeFilter(value: any) {
    this.filterBy = value;
    if (value == 'pending') {
      this.pendingtick = 'flex';
      this.approvedtick = 'none'
      this.rejectedtick = 'none';

    }
    else if (value == 'approved') {
      this.pendingtick = 'none';
      this.approvedtick = 'flex'
      this.rejectedtick = 'none';
    }
    else {
      this.pendingtick = 'none';
      this.approvedtick = 'none'
      this.rejectedtick = 'flex';
    }
    this.getlist();
    this.filterdisplay = 'none';
  }
  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    if (!list || list.length === 0) {
      return [];
  }
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
}

  getcityid(city: any) {
    
    this.dtservice.setCity(city);
    
    this.cityObject=city;
    this.spinner.show()
        this.service.getCampus(city.cityId).subscribe((res: any) => {
          this.campus = res;
          this.spinner.hide();
          this.dtservice.setCampusLIst(this.campus)
          this.campusOptions = this.main.get('campusControl').valueChanges.pipe(
            startWith(''),
            map((value:any) => this.Filter(value ,this.campus,'campusName'))
          )

        });

      
  }
  closefilterDisplay()
  {
    this.filterdisplay='none';
  }
  getclass(campus: any) {
    this.dtservice.setCampus(campus)
      this.campusObject=campus;
        this.campusId=campus.campusId;
        this.dtservice.setCampusID(this.campusId)
        this.spinner.show();
        this.service.getClassAndStream(this.campusId).subscribe((res: any) => {
          this.classAndstream = res;
          this.spinner.hide();
          this.stream = res.classWiseStreams;
          this.class = res.studyClassList;
          this.dtservice.setClassLIst(this.class)
          this.classOptions = this.main.get('classControl').valueChanges.pipe(
            startWith(''),
            map((value:any) => this.Filter(value,this.class,'className' ))
          )
        });

       
  }
  streamList: any;
  getclassId(classid: any) {
        this.dtservice.setClass(classid)
        this.classId = classid.id;
        this.classname=classid.className;
   this.dtservice.setClassID(this.classId)

   
    this.classObject=classid;
    this.getgroup();
   
  }
  getcourseTrack(streamid: any) {
        this.dtservice.setStream(streamid)
        this.streamid = streamid.streamId;
     this.dtservice.setStreamID(this.streamid)
     this.spinner.show();
    this.service.getCourseTrack(this.campusId, this.classId, this.streamid).subscribe((res: any) => {
      this.CampusWiseCourseTracks=res.CampusWiseCourseTracks;
      this.spinner.hide();
      this.dtservice.setCourseTrackLIst(this.CampusWiseCourseTracks)
      this.campustrackOptions = this.main.get('coursetrackcontrol').valueChanges.pipe(
        startWith(''),
        map((value:any) => this.Filter(value,this.CampusWiseCourseTracks,'courseTrackName' ))
      );
    });
    
    this.streamobject=streamid

  }
  setcoursetrackid(CampusWiseCourseTracks:any)
  {
    this.dtservice.setcoursetrack(CampusWiseCourseTracks)
    this.coursetrackid=CampusWiseCourseTracks.courseTrackId
    this.campusTrackId= CampusWiseCourseTracks.campusTrackId;
    this.coursetrackobject=CampusWiseCourseTracks;
    this.dtservice.setcoursetrackID(this.campusTrackId)
    this.getlist();
    this.coursetrackcolor='#CAD2DE'
    this.coursetrackcolor1='#666'
  }
  close()
  {
    const data ={
      list:this.list,
      value:false
    }
    this.dialogRef.close(data)
  }
  verifycoursetrack()
  {
    if(this.coursetrackobject==null)
    { 
      const data='Please Enter CourseTrackDetails'
      this.dialog.open(AlertComponent, {
        width: '800px',
        position: {right:'20px', top: '20px'},
        data: { data }
      });
      this.coursetrackcolor='red'
      this.coursetrackcolor1='red'
    }
    else if( this.coursetrackobject!=null)
    {
      const data ={
        list:this.list,
        value:true,
      }
      this.dialogRef.close(data)
      // this.goto()
    } 
  }
  get()
  {
    if(this.coursetrackobject==null)
      { 
        const data='Please Enter CourseTrackDetails'
        this.dialog.open(AlertComponent, {
          width: '800px',
          position: {right:'20px', top: '20px'},
          data: { data }
        });
        this.coursetrackcolor='red'
        this.coursetrackcolor1='red'
      }
      else if( this.coursetrackobject!=null)
      {
        const data ={
          list:this.list,
          value:false
        }
        this.dialogRef.close(data)
      } 
  }
  verifyCourseTrack2(value:any,editornot:boolean)
  {
   this.verifycoursetrack()
   this.dtservice.courseFeeID=this.list[value].courseFeeId;
   this.dtservice.editornot=editornot;

  }
  getlist() {
    this.spinner.show();
    this.service.getList(this.campusId, this.classId, this.streamid, this.filterBy,this.coursetrackid,this.groupId)
      .subscribe((res: any) => {
        this.list = res;
        this.spinner.hide();
      
 
      });
     
  }

   getlistAftersave(campusid:any,classid:any,streamid:any,coursetrackid:any,groupId:any)
   {
    this.campusId=campusid;
    this.classId=classid;
    this.streamid=streamid;
    this.spinner.show();
    this.service.getList(campusid, classid, streamid, this.filterBy,coursetrackid,groupId)
    .subscribe((res: any) => {
      this.list = res;
      this.spinner.hide();
    })
   }
  goto() {
    this.app=new AppComponent()
    this.app.toggleComponents()
  }
  getGroupobj(item:any)
  {
    this.grouplist=this.dtservice.getGroupLIst();
    this.clearstream()
    this.groupobject=item;
    this.groupId=item.groupId
    this.groupwisestream=this.grouplist.groupWiseStreams

    for (let i = 0; i < this.groupwisestream.length; i++) {
      if (this.groupwisestream[i].groupId == this.groupId) {
        this.streamList = this.groupwisestream[i].StreamList;

        this.dtservice.setStreamLIst(this.streamList)
        this.streamOptions = this.main.get('streamcontrol').valueChanges.pipe(
          startWith(''),
          map((value:any) => this.Filter(value,this.streamList,'streamName' ))
        )

      }
    }
    this.dtservice.setGroup(item)
    
  }
  getgroup()
  {
    this.spinner.show()
    this.service.getGroup(this.campusId,this.classId).subscribe((res:any)=>
    {
      this.grouplist=res;
      this.spinner.hide();
      this.groupNameList=this.grouplist.groupNameList;
      this.dtservice.setGroupLIst(res)
      this.groupName= this.groupNameList.map((grouplist:any)=>grouplist.groupName);
      this.groupOptions=this.main.get('groupcontrol').valueChanges.pipe(
        startWith(''),
        map((value:any) => this.Filter(value,this.groupNameList,'groupName' ))
      )
    })
  }
}
